import { ReactNode } from 'react';
import { TypographyContainer, TypographyCustomPropsType } from './styles';
import { BoxWrapperPropsType } from '../Box/boxHelpers';

type TypographyType = BoxWrapperPropsType &
  TypographyCustomPropsType & {
    as?: keyof HTMLElementTagNameMap;
    children: ReactNode;
  };

export const Typography = ({
  as = 'div',
  variant = 'body',
  fontWeight = 'regular',
  children,
  ...props
}: TypographyType) => {
  return (
    <TypographyContainer as={as} variant={variant} fontWeight={fontWeight} {...props}>
      {children}
    </TypographyContainer>
  );
};
